<div class="copyright">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <p style="text-align:center;">
          All Content Copyright &copy;2019, Milestone Project Services LLC. All Rights Reserved.
        </p>
      </div>
    </div>
  </div>
</div>
